import clsx from "clsx";
import React from "react";
import { MODAL_DELETE_VIEW } from "../../../common/components/modals/constants";
import useModal from "../../../common/components/modals/useModal";
import { CurrentViewBadge } from "./CurrentViewBadge";
import { viewType } from "../../../common/types/search/search";

interface ViewItemProps {
	view: viewType;
	current?: viewType;
	selected: number;
	error?: string;
	onSelect: (id) => void;
	onSelectViewToDelete: (id) => void;
}

export function ViewItem({
	view,
	current,
	selected,
	error,
	onSelect,
	onSelectViewToDelete,
}: ViewItemProps) {
	const { id, name } = view;
	const isSelected = selected === id;
	const isCurrentView = current?.id === id;
	const { onOpenModal } = useModal();

	const handleDelete = (id) => {
		onSelectViewToDelete(id);
		onOpenModal(MODAL_DELETE_VIEW);
	};

	return (
		<div className={clsx("radio-item", { error })}>
			<div className="radio-input">
				<input
					type="radio"
					id={`load-view-${id}`}
					name="load-view"
					value={name}
					checked={isSelected}
					onChange={() => onSelect(id)}
				/>
				<label htmlFor={`load-view-${id}`}>
					{name} <CurrentViewBadge isCurrentView={isCurrentView} />
				</label>
			</div>

			{error && (
				<span className="error-text" role="alert">
					An error occurred: {error}.
				</span>
			)}

			{!isCurrentView && (
				<button
					type="button"
					className="btn btn--secondary btn--icon btn--delete"
					onClick={() => handleDelete(id)}
				>
					Delete
				</button>
			)}
		</div>
	);
}
